import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useMeetingContext } from "../../../../../../context/MeetingContext";
import { useParams } from "react-router-dom";

const WebsiteInput = () => {
  const [displayMode, setDisplayMode] = useState("full");
  const [webpageUrl, setWebpageUrl] = useState("");
  const [mode, setMode] = useState("interactive");
  const [websiteName, setWebsiteName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const { createWebPagePreset, updatePresetId, websiteUpdateData } =
    useMeetingContext();

  const { folderId } = useParams();

  const handleSave = () => {
    createWebPagePreset({
      name: websiteName,
      link: webpageUrl,
      displayMode,
      mode,
      folderId,
      id: updatePresetId,
    });
    setWebsiteName("");
    setWebpageUrl("");
    setDisplayMode("full");
    setMode("interactive");
    setIsOpen(false);
  };

  useEffect(() => {
    if (websiteUpdateData) {
      console.log(websiteUpdateData);
      setWebpageUrl(JSON.parse(websiteUpdateData.settings).link);
      setWebsiteName(websiteUpdateData.name);
      setDisplayMode(JSON.parse(websiteUpdateData.settings).displayMode);
      setMode(JSON.parse(websiteUpdateData.settings).mode);
    }
  }, [websiteUpdateData]);

  return (
    <>
      <Tooltip
        id="mode-info"
        anchorSelect="#mode-info-icon"
        isOpen={isOpen}
        place="bottom"
        noArrow={true}
        style={{
          position: "absolute",
          left: 300,
          top: 100,
          zIndex: 99999999999,
          backgroundColor: "#171D2D",
          color: "white",
          padding: 12,
          borderRadius: 8,
          boxShadow:
            "0 10px 15px -3px rgba(0,0,0,1), 0 4px 6px -4px rgba(0,0,0,1)",
        }}
      >
        <div className="w-64 text-white p-4 rounded-lg">
          <div className="space-y-4">
            <div className="flex items-start gap-2">
              <div className="w-4 h-4 bg-blue-400 rounded flex items-center justify-center mt-1">
                <span className="text-xs">🔗</span>
              </div>
              <div>
                <div className="font-bold">Interactive</div>
                <div className="text-sm ">
                  Let your audience interact with your website. They can click,
                  scroll, and explore freely. Perfect for demonstrations and
                  presentations.
                </div>
              </div>
            </div>
            <div className="flex items-start gap-2">
              <div className="w-4 h-4 bg-green-400 rounded flex items-center justify-center mt-1">
                <span className="text-xs">👆</span>
              </div>
              <div>
                <div className="font-bold">Static</div>
                <div className="text-sm ">
                  You control exactly what your audience sees. Perfect for
                  guided walkthroughs and controlled presentations.
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tooltip>
      <div
        className=" overflow-y-auto"
        // style={{
        //   background:
        //     "linear-gradient(164deg, #615B72 27.68%, #363347 66.87%, #2B2A3C 106.05%)",
        // }}
      >
        <div className="max-w-sm mx-auto px-5 py-4 flex flex-col gap-4">
          {/* Screen Mode Selection */}

          {/* Link Section */}
          <div className="flex flex-col gap-2">
            <h2 className="text-white font-montserrat text-[23px] font-bold leading-[22px] tracking-[-0.18px]">
              Link
            </h2>

            <label className="text-white font-montserrat text-[13px] font-bold leading-[22px] tracking-[-0.18px]">
              Webpage to Share:
            </label>

            <div className="flex items-center bg-white rounded-[10px] px-4 py-1.5">
              <span className="text-[#606060] font-montserrat text-[13px] font-normal">
                https://
              </span>
              <input
                type="text"
                value={webpageUrl}
                onChange={(e) => setWebpageUrl(e.target.value)}
                placeholder=""
                className="flex-1 bg-transparent border-none outline-none text-[#606060] font-montserrat text-[13px] ml-1"
              />
            </div>

            <div className="flex items-center gap-5">
              <label className="text-white font-montserrat text-[13px] font-bold leading-[22px] tracking-[-0.18px]">
                Choose Your Mode
              </label>
              <button
                id="mode-info-icon"
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center justify-center w-4 h-4 rounded-full border border-white cursor-pointer"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.91055 12.8442H5.72055V12.3642C5.83055 12.3642 5.95055 12.3442 6.06055 12.3342C6.17055 12.3242 6.27055 12.2942 6.35055 12.2642C6.49055 12.2142 6.59055 12.1342 6.65055 12.0342C6.71055 11.9342 6.74055 11.8042 6.74055 11.6442V7.78422C6.74055 7.63422 6.70055 7.49422 6.63055 7.37422C6.56055 7.25422 6.47055 7.16422 6.36055 7.09422C6.28055 7.04422 6.16055 6.99422 6.00055 6.94422C5.84055 6.89422 5.69055 6.86422 5.56055 6.85422V6.37422L8.81055 6.20422L8.91055 6.30422V11.5742C8.91055 11.7342 8.94055 11.8642 9.01055 11.9742C9.08055 12.0842 9.17055 12.1642 9.30055 12.2142C9.39055 12.2542 9.49055 12.2942 9.59055 12.3242C9.70055 12.3542 9.81055 12.3742 9.92055 12.3942V12.8742L9.91055 12.8442ZM8.94055 3.79422C8.94055 4.13422 8.81055 4.41422 8.55055 4.65422C8.29055 4.89422 7.98055 5.01422 7.63055 5.01422C7.28055 5.01422 6.96055 4.89422 6.70055 4.65422C6.44055 4.41422 6.31055 4.13422 6.31055 3.79422C6.31055 3.45422 6.44055 3.17422 6.70055 2.93422C6.96055 2.69422 7.27055 2.57422 7.63055 2.57422C7.99055 2.57422 8.30055 2.69422 8.55055 2.93422C8.81055 3.17422 8.93055 3.46422 8.93055 3.79422H8.94055Z"
                    fill="white"
                  />
                  <path
                    d="M7.74 15.2446C11.7385 15.2446 14.98 12.0032 14.98 8.00465C14.98 4.00611 11.7385 0.764648 7.74 0.764648C3.74146 0.764648 0.5 4.00611 0.5 8.00465C0.5 12.0032 3.74146 15.2446 7.74 15.2446Z"
                    stroke="white"
                    strokeMiterlimit="10"
                  />
                </svg>
              </button>
            </div>

            <div className="relative flex items-center justify-between bg-white rounded-[10px] px-4 py-1.5">
              <select
                value={mode}
                onChange={(e) => setMode(e.target.value)}
                className="flex-1 bg-transparent border-none outline-none text-black font-montserrat text-[13px] appearance-none cursor-pointer"
              >
                <option value="interactive">Interactive</option>
                <option value="static">Static</option>
              </select>
              <svg
                width="4"
                height="12"
                viewBox="0 0 4 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="pointer-events-none"
              >
                <path
                  d="M0.0898438 4.01453L1.96984 0.644531L3.99984 3.99453L0.0898438 4.01453Z"
                  fill="#231F20"
                />
                <path
                  d="M3.99984 7.98438L2.11984 11.3544L0.0898438 7.99437L3.99984 7.98438Z"
                  fill="#231F20"
                />
              </svg>
            </div>
          </div>

          {/* Save Section */}
          <div className="flex flex-col gap-1.5 mt-2">
            <h2 className="text-white font-montserrat text-[23px] font-bold leading-[22px] tracking-[-0.18px]">
              Save
            </h2>

            <label className="text-white font-montserrat text-[13px] font-bold leading-[22px] tracking-[-0.18px]">
              Name your Website:
            </label>

            <div className="flex items-center bg-white rounded-[10px] px-4 py-1.5">
              <input
                type="text"
                value={websiteName}
                onChange={(e) => setWebsiteName(e.target.value)}
                placeholder="Access your"
                className="flex-1 bg-transparent border-none outline-none text-[#606060] font-montserrat text-[13px] placeholder:text-[#606060]"
              />
            </div>
          </div>

          {/* Save Button */}
          <div className="flex justify-center mt-4">
            <button
              onClick={handleSave}
              className="flex items-center justify-center px-11 py-2.5 rounded-[10px] bg-[#14B14B] text-white font-poppins text-[15px] font-normal leading-[22px] tracking-[-0.18px] transition-all hover:bg-[#12a043] active:scale-95"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebsiteInput;
